module.exports = __webpack_public_path__ + "img/ico_page_link.58eb00b6.svg";